var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-steps',{attrs:{"direction":"vertical","current":_vm.form.data.length-1}},_vm._l((_vm.form.data),function(item){return _c('a-step',{key:item.ftime,attrs:{"title":_vm.moment(item.ftime).format('YYYY-MM-DD HH:mm:ss'),"description":item.context}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }